<template>
  <div class="hello-wrap" :class="examination?'padding_top70':''">
    <div class="video_box">
      <video
        class="video_el"
        ref="video"
        :src="currentVideo"
        :poster="currentVideoUrl"
        controls
        @play="videoPlay()"
        @pause="videoPause()"
        @timeupdate="timeCurrent()"
        @ended="hangleEnded"
        x5-playsinline
        playsinline
        webkit-playsinline="true"
      ></video>
      <!-- 判断是否wifi -->
      <div class="video_flag" v-show="video_flag">
        <div class="video_title">正在使用非wifi网络，播放将产生流量费用</div>
        <div class="video_btn" @click="hanglePlay">继续播放</div>
      </div>
    </div>
    <div>
      <div  style="padding: 0 16px;box-sizing: border-box;">
      <div class="title">{{currentName}}</div>
      <!-- <div class="money_show"><span>￥</span>199</div> -->
      <div class="item-tiem">
        <div class="item-left">学习进度</div>
        <div class="item-per">
          <div class="cen"></div>
          <div class="cen_col" :style="{width:widthPer}"></div>
        </div>
        <div class="item-left-time">
          {{videoCurrent}}
          <span class="tiem-color">/ {{kcsc}}</span>
        </div>
      </div>
      </div>

      <!-- 课程简介 -->
      <div class="swiper_kc">
        <div class="swiper_item_warp">
          <div class="item_waro" :class="item.id == swiperId ? 'item_left' : '' " v-for="item in swiperKc" :key="item.id" @click="handleSwiper(item.id)">{{item.name}}</div>
        </div>
      </div>
      <!-- 课程目录的显示 -->
      <div class="video_warp" v-if="swiperId == 2">
        <div class="video_tit">
          <span style="font-size: 15px;color: #8B99AF;">01</span>
          <span style="font-weight: 500;font-size: 15px;color: #20242A;">{{lxName}}</span>
        </div>

        <div class="video_list" v-if="otherVideoList&&otherVideoList.length > 0">
          <div class="list_warp"  v-for="item in otherVideoList" :key="item.kcId"  @click="handleOtherVideo(item)">
            <div class="list_left">视频</div>
            <div class="list_center">{{item.kcMc}}</div>
          </div>
        </div>
      </div>
      <div class="video_warp" v-else>
        <div class="video_tit_two" v-html="announcementMag">
        </div>
      </div>

      <div  style="padding: 0 16px;box-sizing: border-box;margin-bottom: 30px;">
     <!-- <div class="kc-other" v-if="otherVideoList&&otherVideoList.length > 0">学习其他培训课程</div>
      <div class="swiper_container" v-if="otherVideoList&&otherVideoList.length > 0">
        <div class="swiper_warp">
          <div
            class="swiper_item"
            v-for="item in otherVideoList"
            :key="item.kcId"
            @click="handleOtherVideo(item)"
          >
            <div class="swiper_text">{{item.kcMc}}</div>
            <div class="swiper_time">{{secondToDate(item.kcSc)}}</div>
          </div>
        </div>
      </div> -->
      <div class="add_warp">
        <div class="notes">注：您还可在电脑上观看培训视频</div>
        <div class="address">
          <div class="address_left">培训地址：http://202.107.251.52:8024/</div>
          <div style="display: flex;align-self: center;">
            <img style="width: 16px;height: 16px;display: block;" src="/static/images/icon-fuzhi.png" alt="">
            <div class="address_btn" :data-clipboard-text="url" @click="handlecopy()">复制</div>
          </div>
        </div>
      </div>

      </div>
    </div>

    <div class="btn" @click="hangleExamination"  v-if="examination">{{examAgin == 5 ? '参加补考':'参加考试'}}</div>
    <div class="item-font" v-if="flag">
      <div class="slide-item">
        <slide-verify
          ref="slideblock"
          @again="onAgain"
          @fulfilled="onFulfilled"
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          :accuracy="accuracy"
          slider-text="向右滑动"
          :imgs="imgs"
          class="item-text"
        ></slide-verify>
      </div>
      <!-- <div>{{msg}}</div> -->
      <!-- <button @click="handleClick">刷新</button> -->
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";

export default {
  data() {
    return {
      token: "",
      video_flag: false, //用来判断是否wifi环境
      qyId: null,
      lxId: null,
      kcId: null,
      netType: null,
      widthPer:null,  //视频进度条的宽
      videoData: null, //当前视频信息
      currentTime: "00:00:00", //时间格式
      videoCurrent:"00:00:00",
      kcsc: null, //课程时长
      TimeDuration: null, //获取到的时间
      last: 0, //判断不能快进
      examination: false, //判断是否 可以去考试
      examAgin: null, //按钮是否为补考 5为补考
      // 拼图验证
      totalTiem: 600, //拼图弹窗倒计时10分钟
      tiem: null, //定时器
      imgs: ["/static/images/xinyon.jpg","/static/images/xinyon2.jpg"],
      accuracy: 1, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      flag: false, //拼图插件的
      url: "http://202.107.251.52:8024/",
      otherVideoList: null,
      isCanExamTimer: null, //是否可以去考试定时器
      fristFlag: true, //第一次标记，刚进来执行一次能否去考试

      // 当前播放的视频
      currentVideo:null,
      // 播放当前视频的默认图片
      currentVideoUrl:null,
      // 播放上传的续播位置
      beforeTime:null,
      // 课程名称
      currentName:null,
	  // 类型名称
	  lxName:null,
      announcementMag:null,  //课程简介
      swiperKc:[{
        name:'课程简介',
        id:1
      },{
        name:'课程目录',
        id:2
      }],
      swiperId:1,  //显示模块
    };
  },
  created() {
    let {
      netType,
      qyId,
      lxId,
      kcId,
      token,
      examination,
      brand,
    } = this.$route.query;
    this.qyId = qyId;
    this.lxId = lxId;
    this.kcId = kcId;
    this.token = token;
    this.netType = netType;
    this.examAgin = examination;
    this.brand = brand;
    // 判断是否wifi环境
    if (netType == "wifi") {
      this.video_flag = false;
    } else {
      this.video_flag = true;
    }
    // 其他课程列表
    // this.getOtherVideoList();
  },
  beforeDestroy() {
    // 销毁前把时长加进记录
    this.insertStudyTime();

    this.myVideo.pause();
    clearInterval(this.tiem);
    clearTimeout(this.isCanExamTimer);
  },
  mounted() {
    // 视频
    this.myVideo = this.$refs.video;
    this.getVideoInfo();

	// 向历史记录中插入当前页面并监听浏览器返回
	// if(window.history && window.history.pushState){
	// 	history.pushState(null,null,document.URL);
	// 	window.addEventListener("popstate",this.goBack(),false);
	// }
	// console.log(window.history)
  },
  destroyed() {
  	// 销毁
	// window.removeEventListener("popstate",this.goBack(),false);
  },
  methods: {
	// 返回小程序的类型页面

    // 切换类型
    handleSwiper(id){
      this.swiperId = id;
    },
    // 把时长加进记录
    insertStudyTime() {
      let spxbSfkw = null;
      let spxbXbjl = parseInt(this.TimeDuration) || 0;
      // console.log(spxbXbjl)
      // console.log(this.TimeDuration)
      if (spxbXbjl == this.videoData.kcSc) {
        spxbSfkw = 1;
      } else {
        spxbSfkw = 0;
      }
      // console.log(this.TimeDuration)
      if (this.TimeDuration != null) {
        this.getVideoDuration(spxbXbjl, spxbSfkw);
      }
    },
    // 每隔十秒请求一次获取总时间来判断要不要去考试
    isCanExam() {
      let { lxId, token } = this;
      let ajax = this.$http.create();
      ajax({
        method: "post",
        url: SOWINURL + "XxKh/getEnterpriseCenter",
        data: {
          lxId,
        },
        headers: {
          token: token,
        },
      })
        .then((json) => {
          if (json.data.result == 1) {
            // 时长加进记录
            this.insertStudyTime();

            let list = json.data.data;
            let xxglYxxsSecond = list.xxglYxxsSecond || 0;
            let totalPxSecond = list.totalPxSecond;
            // console.log(xxglYxxsSecond)
            // console.log(totalPxSecond)
            // 需不需要去考试
            let lxKsgn = list.lxKsgn;
            // 考试是否通过
            let xxglSftg = list.xxglSftg;
            if (xxglYxxsSecond >= totalPxSecond - 5 && lxKsgn == 1 && xxglSftg == 0) {
              this.examination = true;
            }

			this.videoCurrent = this.secondToDate(xxglYxxsSecond)
			// 获取当前的进度
			let percent = ((xxglYxxsSecond/totalPxSecond)*100).toFixed(1);
			if(percent <= 100){
				this.widthPer = percent + '%';
			}else{
				this.widthPer = 100 + '%';
			}
            // 如果需要考试且没达到考试时(刚进来不加载计时器)
            if (!this.fristFlag) {
              // 每10秒检测一次（当培训时长还剩10秒内时间就可以去考试）
              let canExamTime = totalPxSecond - xxglYxxsSecond;
              let countdownTime =
                canExamTime >= 10 || canExamTime < 0 ? 10000 : canExamTime * 1000;
                // console.log(canExamTime)
                // console.log(countdownTime)
              clearTimeout(this.isCanExamTimer);
              this.isCanExamTimer = setTimeout(() => {
                this.isCanExam();
              }, countdownTime);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 点击其他视频跳转
    handleOtherVideo(item) {
      let { qyId, lxId, token, netType, examAgin } = this;
      let kcId = item.kcId;
      let param =
        "?lxId=" +
        lxId +
        "&qyId=" +
        qyId +
        "&kcId=" +
        kcId +
        "&netType=" +
        netType +
        "&token=" +
        token +
        "&examination=" +
        examAgin;
      window.location.href = "/videodetail" + param;
    },
    // 获取当前视频信息
    getVideoInfo() {
      let { qyId, lxId, kcId, token } = this;
      let ajax = this.$http.create();
      let formdata = new FormData();
      formdata.append('qyId', qyId);
      formdata.append('lxId', lxId);
      if(kcId){
        formdata.append('kcId', kcId);
      }else{
        formdata.append('kcId', '');
      }
      const loading = this.$loading({
        lock: false,
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      ajax({
        method: "post",
        url: SOWINURL + "XxKh/getVideoDetail",
        data: formdata,
        headers: {
          token,
		  'content-type': 'application/x-www-form-urlencoded'
        },
      })
        .then((res) => {
          let resData = res.data;
          if (resData.result == 1) {
            let videoData = resData.data;
            let currentKc = videoData.currentKc;
            this.videoData = videoData;
            // 学习的总时长
            this.kcsc = this.secondToDate(videoData.lxTime);
            // 播放当前视频视频
            let currentVideo = null;
            // 播放当前视频的默认图片
            let currentVideoUrl = null;
            // 播放上传的续播位置
            let beforeTime = null;
            // 课程名称
            let currentName = null;
            // 富文本内容
            this.announcementMag = videoData.announcementMag;
            // 课程列表
            this.otherVideoList = videoData.kcList;
			// 获取课程id
			let curriculumId = null;
			// 类型的名称
			this.lxName = videoData.lxName;

            if(currentKc){
              currentVideo = currentKc.videoUrl;
              currentVideoUrl = currentKc.kcPic;
              beforeTime = currentKc.xbjl;
              currentName = currentKc.kcMc;
			  curriculumId = currentKc.kcId;
            }else{
              currentVideo = videoData.kcList[0].videoUrl;
              currentVideoUrl = videoData.kcList[0].kcPic;
              beforeTime = videoData.kcList[0].xbjl;
              currentName = videoData.kcList[0].kcMc;
			  curriculumId = videoData.kcList[0].kcId;
            }

            this.currentVideo = currentVideo;
            this.currentVideoUrl = currentVideoUrl;
            this.currentName = currentName;
			this.kcId = curriculumId;
            //苹果手机只有canplay之后才能设置视频播放位置
            if (this.brand == "iPhone") {
              this.myVideo.addEventListener("canplay", () => {
                this.myVideo.currentTime = beforeTime;
              });
            } else {
              this.myVideo.currentTime = beforeTime;
            }
            this.last = beforeTime;

            // 检测当前是否可以去考试
            this.isCanExam();
          } else {
            this.$notify({
              title: "错误",
              type: "warning",
              message: res.data.errorcode,
              showClose: false,
            });
          }
          loading.close();
        })
        .catch(function (error) {
          console.log(error);
          loading.close();
        });
    },
    // 秒数 转换成时分秒
    secondToDate(result) {
      var h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      var m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      var s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);
      return (result = h + ":" + m + ":" + s);
    },
    // 获取时间
    timeCurrent() {
      let current = this.myVideo.currentTime;
      this.currentTime = this.secondToDate(current);

      this.TimeDuration = current;
      // // 判断视频不能快进
      if (current - this.last > 2) {
        this.myVideo.currentTime = this.last;
      } else {
        this.last = current;
      }
    },
    // 复制
    handlecopy() {
      var clipboard = new Clipboard(".address_btn");
      clipboard.on("success", (e) => {
        this.$notify({
          title: "成功",
          type: "success",
          message: "复制成功",
          showClose: false,
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$notify({
          title: "错误",
          type: "warning",
          message: "手机不支持复制功能",
          showClose: false,
        });
        // 释放内存
        clipboard.destroy();
      });
    },
    // 视频暂停
    videoPause() {
      // 时长加进记录
      this.insertStudyTime();
      // 清除定时器
      clearTimeout(this.isCanExamTimer);
      clearInterval(this.tiem);
    },
    // 视频开始
    videoPlay() {
      //开启计时器
      this.fristFlag = false;
      // 检测当前是否可以去考试
      this.isCanExam();
      // 定时器
      this.tiem = setInterval(() => {
        this.totalTiem--;
        if (this.totalTiem <= 0) {
          this.myVideo.pause();
          this.flag = true;
          clearInterval(this.tiem);
        }
      }, 1000);
    },
    // 视频结束触发
    hangleEnded() {
      // console.log(1);
    },
    // 点击视频继续播放
    hanglePlay() {
      this.video_flag = false;
    },

    // 播放时长插入
    getVideoDuration(time, duration) {
      let { kcId, lxId, token } = this;
      let ajax = this.$http.create();
      ajax({
        method: "post",
        url: SOWINURL + "XxKh/taggedVideo",
        data: {
          kcId,
          lxId,
          spxbXbjl: time,
          spxbSfkw: duration,
        },
        headers: {
          token,
        },
      })
        .then((res) => {
          if (res.data.result == 1) {
            // if (res.data.data == 2) {
            //   this.examination = true;
            // }
          } else {
            // this.$notify({ title: '错误', type: "warning", message: res.data.errorcode, showClose: false, });
            console.log(res.data.errorcode);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 其他课程列表
    // getOtherVideoList() {
    //   let { lxId } = this;
    //   let ajax = this.$http.create();
    //   ajax({
    //     method: "get",
    //     url: SOWINURL + "index/lxKc/recommend",
    //     params: {
    //       lxId,
    //     },
    //     headers: {
    //       token: this.token,
    //     },
    //   })
    //     .then((res) => {
    //       if (res.data.result == 1) {
    //         this.otherVideoList = res.data.data;
    //       } else {
    //         this.$notify({
    //           title: "错误",
    //           type: "warning",
    //           message: res.data.errorcode,
    //           showClose: false,
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    //下面这块是拼图验证的
    onSuccess() {
      this.totalTiem = 30;
      console.log("验证通过");
      this.myVideo.play();
      this.flag = false;
    },
    onFail() {
      console.log("验证不通过");
      this.msg = "";
    },
    onRefresh() {
      console.log("点击了刷新小图标");
      this.msg = "";
    },
    onFulfilled() {
      console.log("刷新成功啦！");
    },
    onAgain() {
      console.log("检测到非人为操作的哦！");
      this.msg = "try again";
      // 刷新
      this.$refs.slideblock.reset();
    },

    // 点击参加考试
    hangleExamination() {
      let { lxId, qyId } = this;
      let ajax = this.$http.create();
      ajax({
        method: "post",
        url: SOWINURL + "XxKh/GeneratTestPapers",
        data: {
          lxId,
        },
        headers: {
          token: this.token,
        },
      })
        .then((json) => {
          if (json.data.result == 1) {
            //跳回小程序页面
            wx.miniProgram.navigateTo({
              url: "/pages/ks/ks?lxId=" + lxId + "&qyId=" + qyId,
            });
            this.myVideo.pause();
          } else {
            this.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.hello-wrap {
  min-height: 100vh;
  background-color: #fff;
  position: relative;
}
.padding_top70 {
  padding-bottom: 70px;
  box-sizing: border-box;
}

.video_box {
  width: 100%;
  height: 220px;
  position: relative;
  background: #000;
}

.video_el {
  width: 100%;
  height: 100%;
}

/* 判断是否wifi */
.video_flag {
  position: absolute;
  top: 0;
  width: 100%;
  text-align: center;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
}

.video_title {
  color: #fff;
  font-size: 14px;
  text-align: center;
  margin-top: 80px;
}

.video_btn {
  width: 86px;
  height: 30px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  background-color: #385efb;
  line-height: 30px;
  margin: 36px auto 0;
  border-radius: 2px;
}

.title {
  font-size: 16px;
  font-weight: 400;
  margin-top: 16px;
  color: #202331;
}
/* 钱 */
.money_show{
  margin-top: 13px;
  font-size: 18px;
  color: #FB3A1B;
}
.money_show span{
  font-size:12px;
}
.item-tiem {
  width: 100%;
  height: 39px;
  line-height: 39px;
  background-color: #F5F9FC;
  display: flex;
  align-self: center;
  border-radius: 19px;
  margin: 15px auto 0;
}
/* 课程简介 */
.swiper_kc{
  padding-top: 28px;
  box-sizing: border-box;
 }
 .swiper_item_warp{
   display: flex;
 }
 .item_waro{
   flex: 50%;
   text-align: center;
 }
 .item_left{
  color: #2287FF;
 }
.item_left:after{
  display: block;
  content: '';
  width: 16px;
  height: 4px;
  margin: 5px auto 6px;
  background-color: #2287FF;
  /* margin-top: 10rpx; */
  border-radius: 4px;
}
/* 课程视频选择 */
.video_warp{

 }
 .video_tit{
   padding: 0 16px;
   box-sizing: border-box;
   height: 48px;
   width: 100%;
   line-height: 48px;
   background-color: #F5F9FC;

}
.video_tit_two{
  padding: 15px 16px;
  box-sizing: border-box;
  width: 100%;
  background-color: #F5F9FC;
      word-wrap: break-word;
      word-break: normal;
}
/* 视频列表 */
.video_list::-webkit-scrollbar {
  display: none;
}
.video_list{
  margin-top: 18px;
  padding: 0 16px;
  box-sizing: border-box;
  max-height: 180px;
  overflow-y: auto;
}
.list_warp{
  display: flex;
  align-items: center;
}
.list_warp:nth-child(n+2){
  margin-top: 26px;
}
.list_left{
  border: 1px solid #91959A;
  border-radius: 4px;
  font-size: 12px;
  color: #5B6066;
  padding: 2px 4px;
  box-sizing: border-box;
  width: 35px;
}
.list_center{
  margin-left: 15px;
  font-size: 14px;
  color: #20242A;
  width: 85%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-per{
  flex: 1;
  width: 100%;
  height: 18px;
  background-color: #D1F3E3;
  margin-top: 12px;
  margin-left: 8px;
  margin-right: 8px;
  position: relative;
  border-radius: 12px;
}
.cen_col{
  height: 18px;
  border-radius: 12px;
  position: absolute;
  /* background: url(/static/images/file_icon_active.png) repeat-x; */
  /* background-size: 100% 100%; */
  /* background-size:cover; */
  top: 0;
  background-color: #59D671;
}
.cen {
  width: 100%;
  height: 18px;
  border-radius: 12px;
  background-color: #D1F3E3;
}

.item-left {
  color: #777C94;
  font-size: 14px;
  padding-left: 12px;
  box-sizing: border-box;
}
.item-left-time{
  color: #59D671;
  font-size: 14px;
}
.kc-other {
  font-size: 16px;
  font-weight: 800;
  margin-top: 30px;
}

.tiem-color {
  color: #000000;
  margin-right: 10px;
}

.swiper_container {
  width: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
}
.swiper_container::-webkit-scrollbar {
  display: none;
}
.swiper_warp {
  white-space: nowrap;
  margin-left: -10px;
}
.swiper_item {
  display: inline-block;
  vertical-align: top;
  white-space: normal;
  word-break: break-all;
  width: 130px;
  height: 80px;
  margin-top: 15px;
  margin-left: 10px;
  background-color: #fff;
  box-shadow: 0 0 5px 0 rgba(180, 211, 246, 0.3);
  border-radius: 5px;
  padding: 10px;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
}

.swiper_text {
  font-size: 12px;
  color: #404479;
  font-weight: 500;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
/* .swiper_time_box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 10px;
} */
.swiper_state {
  color: #385efb;
  font-size: 12px;
}
.swiper_time {
  position: absolute;
  bottom: 10px;
  right: 10px;
  /* width: 34px; */
  /* height: 14px;
  line-height: 14px; */
  padding: 0 4px;
  text-align: center;
  opacity: 0.5;
  font-size: 12px;
  color: #fff;
  background-color: #000000;
  border-radius: 2px;
}
.add_warp{
  margin-top: 30px;
  min-height: 68px;
  background-color: #FFF9F4;
  border-radius: 4px;
  padding: 12px 11px;
  box-sizing: border-box;
}
.notes {
  font-size: 14px;
  color: #F35545;
  font-weight: 400;
  padding-bottom: 12px;
  box-sizing: border-box;
}

.address {
  display: flex;
  align-items: center;

}

.address_left {
  font-size: 14px;
  color: #747270;
  flex: 1;
}

.address_btn {
  color: #FF7B22;
  font-size: 14px;
}

.btn {
  width: 301px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: #2287FF;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  /* margin: 20px auto 0; */
  margin: 0 auto;
  border-radius: 8px;
}

.item-font {
  position: absolute;
  top: 0;
  font-size: 14px;
  width: 100%;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
}

.slide-item {
  padding-left: 30px;
  padding-top: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/wechat_video_detail.vue